import React from 'react';
import { ColoredTextBoxContentModel } from 'src/api/models/ColoredTextBox';
import ColoredTextBox from 'app_previous/molecules/Standard/Shared/ColoredTextBox/ColoredTextBox';

export default function getDynamicColoredTextBox(boxProps: ColoredTextBoxContentModel): React.ReactNode {
  return (
    <ColoredTextBox
      backgroundColor={boxProps.backgroundColor}
      body={boxProps.body}
    />
  );
}
